import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { MdVisibility, MdVisibilityOff, MdWarning, MdMailOutline, MdLockOutline, MdLanguage } from "react-icons/md";

const BROWN = "var(--brown)";
const KH    = "'Khmer OS Siemreap','Noto Sans Khmer',sans-serif";
const MO    = "'Moul','Noto Sans Khmer',serif";

export default function LoginPage() {
  const { login }               = useAuth();
  const { lang, setLang, t }    = useLanguage();
  const [email,    setEmail]    = useState("");
  const [password, setPass]     = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShow]     = useState(false);


  const handleLogin = async () => {
    if (!email || !password) {
      setError(t("សូមបញ្ចូលអ៊ីមែល និង ពាក្យសម្ងាត់"));
      return;
    }
    setLoading(true); setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || t("ចូលប្រព័ន្ធបរាជ័យ"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:"100vh",
      background:"#f0f4fb",
      display:"flex", alignItems:"center", justifyContent:"center",
      fontFamily:KH, padding:16, position:"relative",
    }}>
      <button
        onClick={() => setLang(lang === "km" ? "en" : "km")}
        style={{
          position:"absolute", top:20, right:20,
          display:"flex", alignItems:"center", gap:5,
          padding:"7px 14px", borderRadius:18,
          border:"1px solid #CBD5E1", background:"#fff", color:BROWN,
          cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:KH,
        }}>
        <MdLanguage size={16} />
        {lang === "km" ? "ខ្មែរ" : "EN"}
      </button>

      <div style={{
        background:"#fff",
        borderRadius:12,
        width:420, maxWidth:"100%",
        padding:"36px 32px 28px",
        boxShadow:"0 2px 24px rgba(30,58,138,0.10)",
      }}>

        <div style={{
          display:"flex", alignItems:"center", gap:0,
          marginBottom:28,
        }}>
          <div style={{
            width:80, height:80, borderRadius:"50%",
            flexShrink:0,
            background:"#512304",
            border:"3px solid #C4956A",
            outlineOffset:"3px",
            display:"flex", alignItems:"center", justifyContent:"center",
            overflow:"hidden",
          }}>
            <img
              src={require("../assets/logo.png")}
              alt="Logo"
              style={{ width:"80%", height:"80%", objectFit:"contain" }}
            />
          </div>

          <div style={{
            width:1.5, height:52,
            background:"#CBD5E1",
            margin:"0 18px",
            flexShrink:0,
          }} />

          <div>
            <p style={{
              fontSize:18, fontWeight:700, color:BROWN,
              fontFamily:MO,
              letterSpacing:0.2, marginBottom:3,
              lineHeight:1.3,
              whiteSpace:"nowrap",
              transform:"scaleX(0.78)",
              transformOrigin:"left center",
            }}>
              {t("អគ្គាធិការដ្ឋានពុទ្ធិកសិក្សាជាតិ")}
            </p>
            <p style={{
              fontSize:12.5, color:"#64748B",
              fontFamily:"sans-serif", letterSpacing:0.3,
            }}>
              Inspectorate Management System
            </p>
          </div>
        </div>

        <h2 style={{
          fontSize:19, fontWeight:700,
          color:BROWN, fontFamily:KH,
          textAlign:"center",
          marginBottom:24,
          letterSpacing:0.3,
        }}>
          {t("ចូលប្រើប្រាស់ប្រព័ន្ធ")}
        </h2>

        {error && (
          <div style={{
            background:"#FEE2E2", color:"#991B1B",
            padding:"10px 14px", borderRadius:8,
            fontSize:12, marginBottom:14,
            display:"flex", alignItems:"center", gap:7,
            border:"1px solid #FECACA",
          }}>
            <MdWarning size={15} style={{ flexShrink:0 }} />
            {error}
          </div>
        )}

        <div style={{ marginBottom:14 }}>
          <div style={{
            display:"flex", alignItems:"center",
            border:"1.5px solid #CBD5E1",
            borderRadius:8, padding:"0 12px",
            height:48, background:"#fff",
          }}>
            <MdMailOutline size={18} color="#64748B" style={{ flexShrink:0, marginRight:8 }} />
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key==="Enter" && handleLogin()}
              placeholder={t("អ៊ីមែល *")}
              style={{
                flex:1, border:"none", outline:"none",
                fontSize:13, fontFamily:KH,
                background:"transparent", color:"#1E293B",
              }}
              onFocus={e => e.currentTarget.closest("div").style.borderColor=BROWN}
              onBlur={e  => e.currentTarget.closest("div").style.borderColor="#CBD5E1"}
            />
          </div>
        </div>

        <div style={{ marginBottom:22 }}>
          <div style={{
            display:"flex", alignItems:"center",
            border:"1.5px solid #CBD5E1",
            borderRadius:8, padding:"0 12px",
            height:48, background:"#fff",
          }}>
            <MdLockOutline size={18} color="#64748B" style={{ flexShrink:0, marginRight:8 }} />
            <input
              type={showPass ? "text" : "password"}
              value={password}
              onChange={e => setPass(e.target.value)}
              onKeyDown={e => e.key==="Enter" && handleLogin()}
              placeholder={t("លេខសម្ងាត់ *")}
              style={{
                flex:1, border:"none", outline:"none",
                fontSize:13, fontFamily:KH,
                background:"transparent", color:"#1E293B",
              }}
              onFocus={e => e.currentTarget.closest("div").style.borderColor=BROWN}
              onBlur={e  => e.currentTarget.closest("div").style.borderColor="#CBD5E1"}
            />
            <button onClick={() => setShow(!showPass)} style={{
              background:"none", border:"none",
              cursor:"pointer", color:"#64748B",
              display:"flex", alignItems:"center",
              padding:0, flexShrink:0,
            }}>
              {showPass
                ? <MdVisibilityOff size={18} />
                : <MdVisibility size={18} />
              }
            </button>
          </div>
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width:"100%", height:48,
            background: loading ? "#8d5028" : BROWN,
            color:"#fff", border:"none", borderRadius:8,
            fontSize:15, fontWeight:600,
            cursor: loading ? "not-allowed" : "pointer",
            fontFamily:KH, transition:"background 0.2s",
            display:"flex", alignItems:"center",
            justifyContent:"center", gap:8,
          }}
          onMouseEnter={e => { if (!loading) e.currentTarget.style.background="#8d5028"; }}
          onMouseLeave={e => { if (!loading) e.currentTarget.style.background=BROWN; }}
        >
          {loading && (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              style={{ animation:"spin 0.8s linear infinite", flexShrink:0 }}>
              <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3"/>
              <path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" strokeWidth="3" strokeLinecap="round"/>
            </svg>
          )}
          {loading ? t("កំពុងចូល...") : t("ចូលប្រើប្រាស់")}
        </button>

        <p style={{
          textAlign:"center", fontSize:11,
          color:"#94A3B8", marginTop:20,
          fontFamily:KH,
        }}>
          © 2026 {t("អគ្គាធិការដ្ឋាន")} · {t("ប្រព័ន្ធគ្រប់គ្រង")}
        </p>
      </div>

      <style>{`
        @keyframes spin { to { transform:rotate(360deg); } }
      `}</style>
    </div>
  );
}